import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.storageKey = `encounter-review-scroll:${window.location.pathname}`;
    this.boundStoreScroll = this.storeScrollPosition.bind(this);
    this.bindReviewForms();
    this.restoreScrollPosition();
  }

  disconnect() {
    this.unbindReviewForms();
  }

  bindReviewForms() {
    this.reviewForms = this.element.querySelectorAll(
      'form[action*="/approve_competency"], form[action*="/reject_competency"], form[action*="/approve_all"]'
    );

    this.reviewForms.forEach((form) => {
      form.addEventListener("submit", this.boundStoreScroll);
    });
  }

  unbindReviewForms() {
    if (!this.reviewForms || !this.boundStoreScroll) {
      return;
    }

    this.reviewForms.forEach((form) => {
      form.removeEventListener("submit", this.boundStoreScroll);
    });
  }

  storeScrollPosition() {
    sessionStorage.setItem(this.storageKey, String(window.scrollY));
  }

  restoreScrollPosition() {
    const storedValue = sessionStorage.getItem(this.storageKey);
    if (!storedValue) {
      return;
    }

    const yPosition = parseInt(storedValue, 10);
    if (!Number.isNaN(yPosition)) {
      window.requestAnimationFrame(() => {
        window.scrollTo(0, yPosition);
      });
    }

    sessionStorage.removeItem(this.storageKey);
  }
}
